import { defineStore } from 'pinia'
import axios from 'axios'
import { useLangStore } from './langStore'

export const useBiographyPageStore = defineStore('biographyPage', {
    state: () => ({
        biography : {
            biographyTR: '',
            biographyEN: '',
            artPerspectiveTR: '',
            artPerspectiveEN: '',
            artInterPretationTR: '',
            artInterPretationEN: ''
        },
        biographyDTO:{
            biography: '',
            artPerspective: '',
            artInterPretation: ''
        },
        achievements : {
            personalExhibitions: [],
            selectedGroupExhibitions: [],
            symposiums: [],
            fairs: [],
            prizes: []
        },
        achievementsDto: {
            personalExhibitions: [],
            selectedGroupExhibitions: [],
            symposiums: [],
            fairs: [],
            prizes: []
        }
    }),
    getters: {
        filteredBiographyInfo: (state) => {
            const lang = useLangStore().language;
            if(lang === 'tr'){
                state.biographyDTO.biography = state.biography.biographyTR;
                state.biographyDTO.artInterPretation = state.biography.artInterPretationTR;
                state.biographyDTO.artPerspective = state.biography.artPerspectiveTR;
            }
            if(lang === 'en'){
                state.biographyDTO.biography = state.biography.biographyEN;
                state.biographyDTO.artInterPretation = state.biography.artInterPretationEN;
                state.biographyDTO.artPerspective = state.biography.artPerspectiveEN;
            }
            return state.biographyDTO;
        },
        filteredAchievementInfo: (state) => {
            const lang = useLangStore().language;
            
            const getLocalizedList = (list) => {
                return list.map(item => ({
                    year: item.year,
                    text: lang === 'tr' ? item.textTR : item.textEN,
                    orderNo: item.orderNo
                }));
            };

            state.achievementsDto.personalExhibitions = getLocalizedList(state.achievements.personalExhibitions);
            state.achievementsDto.selectedGroupExhibitions = getLocalizedList(state.achievements.selectedGroupExhibitions);
            state.achievementsDto.symposiums = getLocalizedList(state.achievements.symposiums);
            state.achievementsDto.fairs = getLocalizedList(state.achievements.fairs);
            state.achievementsDto.prizes = getLocalizedList(state.achievements.prizes);

            return state.achievementsDto;
        }
    },
    actions: {
        async fetchBiographyData(){
            try {
                const biographyResponse = await axios.get('/api-path/Biography/get-bio');
                this.biography.biographyTR = biographyResponse.data.biographyTR;
                this.biography.biographyEN = biographyResponse.data.biographyEN;
                this.biography.artInterPretationTR = biographyResponse.data.artInterPretationTR;
                this.biography.artInterPretationEN = biographyResponse.data.artInterPretationEN;
                this.biography.artPerspectiveTR = biographyResponse.data.artPerspectiveTR;
                this.biography.artPerspectiveEN = biographyResponse.data.artPerspectiveEN;

                const achievementResponse = await axios.get('/api-path/Biography/get-achievements');
                this.achievements.personalExhibitions = achievementResponse.data.personalExhibitions;
                this.achievements.selectedGroupExhibitions = achievementResponse.data.selectedGroupExhibitions;
                this.achievements.symposiums = achievementResponse.data.symposiums;
                this.achievements.fairs = achievementResponse.data.fairs;
                this.achievements.prizes = achievementResponse.data.prizes;
            } catch (err) {
                console.error(err);
            }
        }
    }
});